module.exports = __webpack_public_path__ + "static/media/maxut.8d34f7da.png";